import React from 'react';
import { ROW_ITEM_DRAG_TYPE } from '../../dataTable/components/Row';
import { useDragLayer } from 'react-dnd';
import AccurityIcon from '../../icon/components/AccurityIcon';
function collectDragLayerProps(monitor) {
    return {
        item: monitor.getItem(),
        isDragging: monitor.isDragging(),
        currentOffset: monitor.getSourceClientOffset(),
        initialCursor: monitor.getInitialClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
    };
}
function getItemStyles(props) {
    var initialOffset = props.initialOffset, currentOffset = props.currentOffset, initialCursor = props.initialCursor;
    if (!initialOffset || !currentOffset || !initialCursor) {
        return {
            display: 'none'
        };
    }
    // Some magic numbers here to position the 'drag box' under the cursor so that the cursor is above the 'drag icon'
    var x = initialCursor.x + (currentOffset.x - initialOffset.x) - 20;
    var y = initialCursor.y + (currentOffset.y - initialOffset.y) - 36;
    var transform = "translate(" + x + "px, " + y + "px)";
    return {
        transform: transform,
        WebkitTransform: transform,
        display: 'inline-block',
        maxWidth: '300px',
        background: '#f0f0f0',
        border: 'none',
        padding: '10px',
        paddingRight: '20px',
    };
}
var ListRowDragLayer = function () {
    var _a, _b;
    var dragLayerProps = useDragLayer(collectDragLayerProps);
    var isDragging = dragLayerProps.isDragging, item = dragLayerProps.item;
    if (!isDragging || item.type !== ROW_ITEM_DRAG_TYPE) {
        return null;
    }
    return (React.createElement("div", { className: "customLayer" },
        React.createElement("div", { style: getItemStyles(dragLayerProps), className: "draggedCell" },
            React.createElement(AccurityIcon, { iconName: "mui:DragIndicator", fontSize: "small" }), (_b = (_a = dragLayerProps === null || dragLayerProps === void 0 ? void 0 : dragLayerProps.item) === null || _a === void 0 ? void 0 : _a.rowItem) === null || _b === void 0 ? void 0 :
            _b.name)));
};
export default ListRowDragLayer;
//# sourceMappingURL=ListRowDragLayer.js.map